import ApplicationController from 'javascript/controllers/application_controller';

import { reloadWithTurbolinks } from 'javascript/utils/utils';

export default class extends ApplicationController {
  reload() {
    reloadWithTurbolinks(this.window, this.document)();
  }
}
